<template>
  <DialogBulkOperationDetails
    v-if="showDialog && currentNotification"
    v-model="showDialog"
    :bulk-notification="currentNotification"
    :has-next="notificationQueue.length > 0"
    :has-previous="viewedNotifications.length > 0"
    :queue-count="originalQueueLength"
    :current-index="originalQueueLength - notificationQueue.length"
    @approve="handleApprove"
    @reject="handleReject"
    @close="handleClose"
    @next="handleNext"
    @previous="handlePrevious"
  />
</template>

<script>
import { registerBulkNotificationCallback } from "../authentication/useFacility";
import DialogBulkOperationDetails from "./DialogBulkOperationDetails.vue";
import useUser from "../authentication/useUser";
import useNotifications from "./useNotifications";
import { UPDATE_NOTIFICATION } from "./graphql";

export default {
  name: "GlobalBulkNotificationPopup",
  components: {
    DialogBulkOperationDetails,
  },
  data() {
    return {
      showDialog: false,
      currentNotification: null,
      notificationQueue: [],
      originalQueueLength: 0,
      viewedNotifications: [],
    };
  },
  setup() {
    const { canApproveBulkOperations } = useUser();
    const {} = useNotifications();
    return {
      canApproveBulkOperations,
    };
  },
  mounted() {
    registerBulkNotificationCallback(this.handleBulkNotification);
  },
  methods: {
    handleBulkNotification(notifications) {
      if (
        notifications &&
        notifications.length > 0 &&
        this.canApproveBulkOperations
      ) {
        const sorted = [...notifications].sort((a, b) => {
          return new Date(b.insertedAt) - new Date(a.insertedAt);
        });
        this.notificationQueue = sorted;
        this.originalQueueLength = sorted.length;
        this.showNextNotification();
      }
    },

    showNextNotification() {
      if (this.notificationQueue.length > 0) {
        if (this.currentNotification) {
          this.viewedNotifications.push(this.currentNotification);
        }
        this.currentNotification = this.notificationQueue.shift();
        this.showDialog = true;
      } else {
        this.currentNotification = null;
        this.showDialog = false;
      }
    },
    handleClose() {
      this.showDialog = false;
      this.currentNotification = null;
      this.notificationQueue = [];
      this.originalQueueLength = 0;
      this.viewedNotifications = [];
    },

    handleNext() {
      this.showNextNotification();
    },

    handlePrevious() {
      if (this.viewedNotifications.length > 0) {
        if (this.currentNotification) {
          this.notificationQueue.unshift(this.currentNotification);
        }
        this.currentNotification = this.viewedNotifications.pop();
        this.showDialog = true;
      }
    },

    removeProcessedNotification(processedId) {
      this.notificationQueue = this.notificationQueue.filter(
        (n) => n.id !== processedId
      );
      this.viewedNotifications = this.viewedNotifications.filter(
        (n) => n.id !== processedId
      );

      if (this.notificationQueue.length > 0) {
        this.currentNotification = this.notificationQueue.shift();
      } else {
        this.currentNotification = null;
        this.showDialog = false;
      }
    },

    async handleApprove(bulkNotification) {
      try {
        const response = await this.$apollo.mutate({
          mutation: UPDATE_NOTIFICATION,
          variables: {
            id: bulkNotification.id,
            action: "approved",
            status: "resolved",
          },
        });

        if (response?.data?.updateNotification) {
          const store =
            this.$store ||
            this.$root.$store ||
            (this.$root && this.$root.$options && this.$root.$options.store);
          if (store) {
            store.dispatch("alerts/addAlert", {
              type: "success",
              message: "Bulk operation approved successfully.",
              timeout: 5,
            });
          }

          this.removeProcessedNotification(bulkNotification.id);
        }
      } catch (error) {
        const store =
          this.$store ||
          this.$root.$store ||
          (this.$root && this.$root.$options && this.$root.$options.store);
        if (store) {
          store.dispatch("alerts/addAlert", {
            type: "error",
            message: "Failed to approve bulk operation. Please try again.",
            timeout: 5,
          });
        }
      }
    },
    async handleReject(bulkNotification, reason = null) {
      try {
        const variables = {
          id: bulkNotification.id,
          action: "rejected",
          status: "resolved",
        };

        if (reason) {
          variables.reason = reason;
        }

        const response = await this.$apollo.mutate({
          mutation: UPDATE_NOTIFICATION,
          variables,
        });

        if (response?.data?.updateNotification) {
          let message = "Bulk operation rejected successfully.";
          if (reason) {
            message += ` Reason: ${reason}`;
          }

          const store =
            this.$store ||
            this.$root.$store ||
            (this.$root && this.$root.$options && this.$root.$options.store);
          if (store) {
            store.dispatch("alerts/addAlert", {
              type: "success",
              message,
              timeout: 5,
            });
          }

          this.removeProcessedNotification(bulkNotification.id);
        }
      } catch (error) {
        const store =
          this.$store ||
          this.$root.$store ||
          (this.$root && this.$root.$options && this.$root.$options.store);
        if (store) {
          store.dispatch("alerts/addAlert", {
            type: "error",
            message: "Failed to reject bulk operation. Please try again.",
            timeout: 5,
          });
        }
      }
    },
  },
};
</script>
